<template>
  <div class="confirmation">
    <div class="confirmation__section confirmation__section--has-image">
      <div class="confirmation__image">
        <i class="icon--check-success" style="height: 6em; width: 4em;"></i>
      </div>
      <div class="confirmation__content">
        <h2>Vielen Dank!</h2>
        <p>
          Deine Bewerbung ist bei uns eingegangen.<br />
          Eine Bestätigung haben wir an
          <strong v-text="email">[E-Mail]</strong>
          geschickt.
        </p>
      </div>
    </div>
    <div class="confirmation__section">
      <div class="confirmation__content">
        <h2 style="font-size: 1.3em;">Was als nächstes passiert:</h2>
        <p>
          Jemand aus unserem Team meldet sich in den nächsten Tagen bei Dir. In
          der Regel telefonisch. Wenn Du noch Fragen hast, schaue bitte in
          unseren <a href="/haeufige-fragen">FAQ-Bereich</a>.
        </p>
      </div>
    </div>
    <div class="confirmation__cta">
      <a href="https://www.rewe-lieferservice.jobs" class="btn btn-primary">
        Zurück zur Startseite
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Confirmation',
  props: {
    email: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';

.confirmation {
  width: 100%;
  margin: 0 auto;
  padding-bottom: utils.f-rem-calc(utils.$v-wizard-sm-gap-y);

  @include utils.bs-media-breakpoint-up(md) {
    padding: utils.f-rem-calc(40) utils.f-rem-calc(100) 0;
  }

  @include utils.bs-media-breakpoint-up(lg) {
    padding: utils.f-rem-calc(0) utils.f-rem-calc(200);
  }

  @at-root #{&}__section {
    margin-bottom: utils.f-rem-calc(50);

    @at-root #{&}--has-image {
      display: flex;
    }
  }

  @at-root #{&}__content {
    > * {
      margin-bottom: 0;

      + * {
        margin-top: 10px;
      }
    }

    h2 {
      font-size: 28px;
      margin: 0;
    }

    p {
      line-height: 1.5;
    }
  }

  @at-root #{&}__image {
    margin-right: 16px;
    flex-shrink: 0;
  }

  @at-root #{&}__cta {
    display: flex;
    justify-content: center;
  }
}
</style>
